import {useQuery} from '@tanstack/react-query';

import {useStores} from '../../stores/use-stores';
import {getPaymentCard} from '../../transport/paymentCardApiV2';

import type {GetPaymentCardResponse} from './types';

export const PAYMENT_CARD_QUERY_KEY_BASE = ['paymentCard'] as const;

/** @deprecated Use PAYMENT_CARD_QUERY_KEY_BASE for prefix matching */
export const PAYMENT_CARD_QUERY_KEY = PAYMENT_CARD_QUERY_KEY_BASE;

/**
 * Fetch the user's saved payment card
 * Returns { card: PaymentCard | null }
 *
 * Query key includes storeId for proper cache scoping per store.
 * Cache automatically invalidates when user switches stores.
 *
 * @param enabled - Whether to fetch (default: true)
 */
export const usePaymentCard = (enabled: boolean = true) => {
  const {shopSelectionStore} = useStores();
  const storeId = shopSelectionStore.selectedStore?.id;

  return useQuery<GetPaymentCardResponse>({
    queryKey: [...PAYMENT_CARD_QUERY_KEY_BASE, storeId],
    queryFn: getPaymentCard,
    enabled: enabled && !!storeId,
  });
};
